import * as amplitude from '@amplitude/analytics-browser';
import events from '@spa/shared/hooks/tracking/events';
import {
  mapSearchBarClickedEventData,
  mapCityClickedData,
  mapOfferCardClickedEventData,
  mapTrackSignupEventData,
  mapViewSignupPage,
  mapSignupTabChanged,
  mapFiltersAppliedEventData,
  mapSortChangedEventData,
  mapUniTrustSearchClickedData,
  mapOfferAlertCreatedEventData,
  mapSearchResultsSummaryData,
  mapExtraGuestAdded,
  mapDatesAppliedEventData,
  mapVisitUnpublishedListingEventData,
  mapPriceReviewData
} from '@spa/shared/hooks/tracking/services/amplitude/mappers';

export const initAmplitude = (apiKey, userId = null) => {
  amplitude.init(apiKey, {
    serverZone: 'EU',
    userId,
    autocapture: false
  });
};

export const trackAmplitude = (eventName, eventData, context) => {
  if (!eventData) {
    amplitude.track(eventName);

    return Promise.resolve();
  }

  const mappedEventData = mapEventData(eventName, eventData, context);

  if (!mappedEventData || Object.keys(mappedEventData).length === 0) {
    return Promise.resolve();
  }

  return new Promise(resolve => {
    amplitude.track(eventName, mappedEventData);
    resolve();
  });
};

export const setUserId = userId => {
  amplitude.setUserId(userId);
};

export const setCustomUserProperties = (isUnauthenticated, role) => {
  const identify = new amplitude.Identify();

  identify.set('authentication_type', guestAuthorizationStatus(isUnauthenticated));
  identify.set('user_type', role);

  amplitude.identify(identify);
};

const guestAuthorizationStatus = isUnauthenticated => (isUnauthenticated ? 'unauthenticated' : 'authenticated');

const mapEventData = (eventName, eventData, context) => {
  const mapFn = eventNameToMapFn[eventName];

  return mapFn ? mapFn(eventData, context) : null;
};

const eventNameToMapFn = {
  [events.searchBarClicked]: mapSearchBarClickedEventData,
  [events.cityClicked]: mapCityClickedData,
  [events.offerCardClicked]: mapOfferCardClickedEventData,
  [events.trackSignupCompleted]: mapTrackSignupEventData,
  [events.viewSignupPage]: mapViewSignupPage,
  [events.signupTabChanged]: mapSignupTabChanged,
  [events.filtersApplied]: mapFiltersAppliedEventData,
  [events.sortChanged]: mapSortChangedEventData,
  [events.uniTrustClicked]: mapUniTrustSearchClickedData,
  [events.offerAlertCreated]: mapOfferAlertCreatedEventData,
  [events.searchResultsSummary]: mapSearchResultsSummaryData,
  [events.extraGuestAdded]: mapExtraGuestAdded,
  [events.datesApplied]: mapDatesAppliedEventData,
  [events.visitUnpublishedListing]: mapVisitUnpublishedListingEventData,
  [events.priceReview]: mapPriceReviewData
};
